import { useNavigate } from 'react-router-dom';
import { LogOut, User, Bell, Shield, HelpCircle } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';
import { useProfile } from '@/hooks/useProfile';
import toast from 'react-hot-toast';

export function SettingsPage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { profile } = useProfile();

  const handleSignOut = async () => {
    await signOut();
    toast.success('Sesión cerrada');
    navigate('/login');
  };

  const MENU_ITEMS = [
    { icon: User, label: 'Mi Perfil', description: 'Edita tu información personal', onClick: () => navigate('/profile') },
    { icon: Bell, label: 'Notificaciones', description: 'Configura alertas y recordatorios', onClick: () => toast('Próximamente') },
    { icon: Shield, label: 'Privacidad', description: 'Configuración de privacidad y datos', onClick: () => toast('Próximamente') },
    { icon: HelpCircle, label: 'Ayuda', description: 'Centro de ayuda y soporte', onClick: () => toast('Próximamente') },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <h1 className="font-heading text-3xl tracking-wider">CONFIGURACIÓN</h1>

      {/* Profile card */}
      {profile && (
        <Card className="flex items-center gap-3" onClick={() => navigate('/profile')}>
          {profile.profile_photo_url ? (
            <img src={profile.profile_photo_url} alt="" className="w-14 h-14 rounded-full object-cover" />
          ) : (
            <div className="w-14 h-14 rounded-full bg-brand-black flex items-center justify-center">
              <User size={24} className="text-brand-yellow" />
            </div>
          )}
          <div>
            <p className="font-semibold">{profile.display_name || 'Sin nombre'}</p>
            <p className="text-sm text-gray-500">{profile.phone}</p>
          </div>
        </Card>
      )}

      {/* Menu items */}
      <div className="space-y-2">
        {MENU_ITEMS.map(({ icon: Icon, label, description, onClick }) => (
          <Card key={label} hover onClick={onClick} className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Icon size={20} className="text-brand-black" />
            </div>
            <div>
              <p className="text-sm font-semibold">{label}</p>
              <p className="text-xs text-gray-500">{description}</p>
            </div>
          </Card>
        ))}
      </div>

      {/* Sign out */}
      <Button variant="outline" fullWidth onClick={handleSignOut} className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700">
        <LogOut size={16} className="mr-2" />
        Cerrar sesión
      </Button>

      {/* Version info */}
      <p className="text-center text-xs text-gray-400">
        PartRunner Portal v0.1.0 — Construido con ❤️
      </p>
    </div>
  );
}
